import { CommonDataService } from 'src/app/core/services/common-data.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { BookingService } from '../../services/booking.service';
import { Component, Injector, OnInit } from '@angular/core';
import { DropdownOptionsService } from './../../../../core/services/dropdown-options.service';
import { DatePipe } from '@angular/common';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { FacilityService } from 'src/app/core/services/facility.service';

@Component({
  selector: 'laas-booking-search-for-forwarder-header-edit',
  templateUrl: './booking-search-for-forwarder-header-edit.component.html',
  styleUrls: ['./booking-search-for-forwarder-header-edit.component.scss'],
})
export class BookingSearchForForwarderHeaderEditComponent extends SessionBaseComponent implements OnInit {

  bookingModel: any;
  carrierPaymentTypeOptions: any[];
  deliveryTypeOptions: any[];
  deliverSubTypeOptions: any[];
  bookingTypeOptions: any[];
  chargeOptions: any[];
  forwarderOptions: any[];
  carTypeOptions: any[];
  carSeqOptions: any[];
  letterHeadOptions: any[];
  billCorpOptions: any[];
  pickupLocationOptions: any[];
  incoTermOptions: any[];
  bookingStatusOptions: any[];
  rfqAreaOptions: any[];
  facilityOptions: any[];
  payTypeOptions: any[];
  countryOptions: any[];
  cityOptions: any[];
  areaOptions: any[];
  shipMethodOptions: any[];

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
    private dropdownOptionService: DropdownOptionsService,
    private datePipe: DatePipe
  ) {
    super(injector);

    this.forwarderOptions = [];
    this.carTypeOptions = [];
    this.carSeqOptions = [];
    this.letterHeadOptions = [];
    this.billCorpOptions = [];
    this.carrierPaymentTypeOptions = [];
    this.deliveryTypeOptions = [];
    this.deliverSubTypeOptions = [];
    this.bookingTypeOptions = [];
    this.chargeOptions = [];
    this.pickupLocationOptions = [];
    this.incoTermOptions = [];
    this.bookingStatusOptions = [];
    this.rfqAreaOptions = [];
    this.facilityOptions = [];
    this.payTypeOptions = [];
    this.countryOptions = [];
    this.cityOptions = [];
    this.areaOptions = [];
    this.shipMethodOptions = [];

    this.bookingModel = this.routeStateService.getCurrent().data;
    this.bookingModel.tmpCarSeq = this.bookingModel.carSeq?.slice(-4);
    this.bookingModel.incoTerm = '';
    this.bookingModel.tmpAssignDate = this.datePipe.transform(this.bookingModel.assignDate, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
    this.bookingModel.flyDate1TimeZone = this.datePipe.transform(this.bookingModel.flyDate1, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
    this.bookingModel.flyDate2TimeZone = this.datePipe.transform(this.bookingModel.flyDate2, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    const bookingNo = this.routeStateService.getCurrent().data.bookingNo;

    this.dropdownOptionService.getPayTypeOptions().subscribe({
      next: (options: any[]) => {
        this.payTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getCarrierPaymentTypeOptions().subscribe({
      next: (options: any[]) => {
        this.carrierPaymentTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getBookingTypeOptions().subscribe({
      next: (options: any[]) => {
        this.bookingTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getCarTypeOptions().subscribe({
      next: (options: any[]) => {
        this.carTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getChargeOptions().subscribe({
      next: (options: any[]) => {
        this.chargeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDeliveryTypeOptions(false).subscribe({
      next: (options: any[]) => {
        this.deliveryTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDeliverySubTypeOptions('O').subscribe({
      next: (options: any[]) => {
        this.deliverSubTypeOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.commonDataService
      .getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm')
      .subscribe({
        next: (result) => {
          this.incoTermOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeKey}-${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });

    this.dropdownOptionService.getBookingStatusOptions().subscribe({
      next: (options: any[]) => {
        this.bookingStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: (options: any[]) => {
        this.shipMethodOptions = options.map((x) => ({
          label: `${x.optionCode}-${x.optionDesc}`,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getCountryOptions().subscribe({
      next: (options: any[]) => {
        this.countryOptions = options.map((x) => ({
          label: x.countryName,
          value: x.countryCode,
        }));
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.cityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
      },
    });

    this.dropdownOptionService.getAllAreaOptions().subscribe({
      next: (options: any[]) => {
        this.areaOptions = options.map((x) => ({
          label: x.rfqAreaName,
          value: x.rfqAreaCode,
        }));
      },
    });

    this.bookingModel.tmpCarSeq = this.bookingModel.carSeq?.slice(-4);

    if (this.bookingModel.deliveryType.indexOf('(') > -1) {
      this.bookingModel.deliveryType = this.bookingModel.deliveryType
        .substring(0, this.bookingModel.deliveryType.indexOf('('))
        .toUpperCase();
    } else {
      this.bookingModel.deliveryType = this.bookingModel.deliveryType.toUpperCase();
    }

    this.dropdownOptionService
      .getLetterOrgOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {

          this.letterHeadOptions = options.map((x) => ({
            label: x.legalEntityOUName,
            value: x.legalEntityOUCode,
          }));

          this.billCorpOptions = options.map((x) => ({
            label: x.billOUName,
            value: x.billOUCode,
          }));
        },
      });

    this.dropdownOptionService
      .getForwarderOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.forwarderOptions = options.map((x) => ({
            label: x.optionDesc,
            value: x.optionCode,
          }));
        },
      });

    this.dropdownOptionService
      .getPickupLocationOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.pickupLocationOptions = options.map((x) => ({
            label: x.optionDesc,
            value: x.optionCode,
          }));
        },
      });

    this.dropdownOptionService
      .getCarSeqOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.carSeqOptions = options.map((x) => ({
            label: x.optionDesc,
            value: x.optionCode?.replace(':', ''),
          }));
        },
      });

    this.dropdownOptionService
      .getAreaOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.rfqAreaOptions = options.map((x) => ({
            label: x.optionDesc,
            value: x.optionCode,
          }));
        },
      });

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
  }

  saveBtnClick(event: any): void {
    let updateParams: any = {};
    updateParams.facility = this.bookingModel.facility;
    updateParams.bookingNo = this.bookingModel.bookingNo;
    updateParams.mawb = this.bookingModel.mawb;
    updateParams.expressBill = this.bookingModel.expressBill;
    updateParams.flightNo1 = this.bookingModel.flightNo1;
    updateParams.flyDate1 = isNullOrEmpty(this.bookingModel.flyDate1TimeZone) ? null : new Date(this.bookingModel.flyDate1TimeZone).toISOString();
    updateParams.flightNo2 = this.bookingModel.flightNo2;
    updateParams.flyDate2 = isNullOrEmpty(this.bookingModel.flyDate2TimeZone) ? null : new Date(this.bookingModel.flyDate2TimeZone).toISOString();
    updateParams.updateUser = this.userProfile.userName;
    updateParams.updateDt = new Date().toISOString();

    this.bookingService.updateBookingForForwarder(updateParams).subscribe({
      next: (result: any) => {
        this.translateService.get('Common.Message.SuccessSave').subscribe({
          next: (msg) => {
            this.toastService.success(msg);
            this.routeStateService.loadPrevious();
          }
        });
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error);
      },
    });
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }
}
